import { useSelector } from 'react-redux';
import { useLocation, Navigate } from 'react-router-dom';
import { getSlugByLang } from '../common/Helper';

const LanguagePrefixRedirect = () => {
    const user = useSelector((state) => state.user);
    const location = useLocation();
    const lang = getSlugByLang(user?.language) || 'en';

    // Avoid double prefixing (e.g., /en/en/tour)
    const isAlreadyPrefixed = /^\/[a-z]{2}(\/|$)/.test(location.pathname);
    if (isAlreadyPrefixed) {
        return null;
    }

    return <Navigate to={`/${lang}${location.pathname}`} replace />;
};
export default LanguagePrefixRedirect
